import { createWidget } from '@alfa-bank/site-util-create-widget';
import { Plate as CorePlate } from '@alfalab/core-components-plate';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import type { IDepsDesktop, TPropsDesktop } from '../models';
import { Plate as Component } from '../plate';
import { configDesktop } from '../config';

export const PlateDesktop = createWidget<IDepsDesktop, TPropsDesktop>(
    { CorePlate, Text, config: configDesktop },
    { priorityStyler: true }
)(Component);
